/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {lookup} from '../api'

export const useMutationLookup = createReactQueryMutationHook('lookup', lookup)
